import React from 'react';

import { CollectiveFilterProvider } from './CollectiveFilterContext';
import { ToastProvider } from './toastContext';
import SmartReloadWrapper from 'components/SmartReloadWrapper';
import { DrawerProvider } from 'global/DrawerContext';
import { EditStatusProvider } from 'global/EditStatusContext';
import { HorizontalSubmenuProvider } from 'global/HorizontalMenuContext';
import { MenuProvider } from 'global/MenuContext';
import { MenuSelectionProvider } from 'global/MenuSelectionContext';
import { ModalProvider } from 'global/ModalContext';
import { NotificationsProvider } from 'global/NotificationsContext';
import { ReportProvider } from 'global/ReportContext';
import { SupportProvider } from 'global/SupportContext';
import { PageHeaderProvider } from 'global/PageHeaderContext';
import { TabProvider } from 'global/TabContext';
import { TrajectoryActivitiesProvider } from 'global/TrajectoryActivitiesContext';
import { TrajectoryDonationsProvider } from 'global/TrajectoryDonationsContext';
import { TrajectoryExpensesProvider } from 'global/TrajectoryExpensesContext';
import { TrajectoryTimeLineProvider } from 'global/TrajectoryTimeLineContext';
import { TrajectoryValidVotesProvider } from 'global/TrajectoryValidVotesContext';
import { UserPersonProvider } from 'global/UsePersonContext';
import { UserProvider } from 'global/UserContext';
import { WebSocketProvider } from 'global/WebSocketContext';
import { FilterGlobalProvider } from 'hooks/useFilterGlobal';
import { MenuTitleProvider } from 'hooks/useMenuTitleContext';
import { SidebarProvider } from 'hooks/useSideBar';
import DynamicStyledThemeProvider from 'providers/DynamicStyledThemeProvider';
import { IChildTypes } from 'types/childrenTypes';

const ProviderContext: React.FC<IChildTypes> = ({ children }) => {
  return (
    <DynamicStyledThemeProvider>
      <ToastProvider>
        <UserProvider>
          <WebSocketProvider>
            <NotificationsProvider>
              <MenuProvider>
                <MenuSelectionProvider>
                  <SupportProvider>
                    <MenuTitleProvider>
                      <SidebarProvider>
                        <TabProvider>
                          <PageHeaderProvider>
                          <UserPersonProvider>
                            <EditStatusProvider>
                              <ModalProvider>
                                <ReportProvider>
                                  <DrawerProvider>
                                    <FilterGlobalProvider>
                                      <TrajectoryTimeLineProvider>
                                        <TrajectoryValidVotesProvider>
                                          <TrajectoryActivitiesProvider>
                                            <TrajectoryExpensesProvider>
                                              <TrajectoryDonationsProvider>
                                                <HorizontalSubmenuProvider>
                                                  <CollectiveFilterProvider>
                                                    <SmartReloadWrapper>
                                                      {children}
                                                    </SmartReloadWrapper>
                                                  </CollectiveFilterProvider>
                                                </HorizontalSubmenuProvider>
                                              </TrajectoryDonationsProvider>
                                            </TrajectoryExpensesProvider>
                                          </TrajectoryActivitiesProvider>
                                        </TrajectoryValidVotesProvider>
                                      </TrajectoryTimeLineProvider>
                                    </FilterGlobalProvider>
                                  </DrawerProvider>
                                </ReportProvider>
                              </ModalProvider>
                            </EditStatusProvider>
                          </UserPersonProvider>
                          </PageHeaderProvider>
                        </TabProvider>
                      </SidebarProvider>
                    </MenuTitleProvider>
                  </SupportProvider>
                </MenuSelectionProvider>
              </MenuProvider>
            </NotificationsProvider>
          </WebSocketProvider>
        </UserProvider>
      </ToastProvider>
    </DynamicStyledThemeProvider>
  );
};

export default ProviderContext;
